import "./ArchiveProductTemplate.module.css"
import TrendMitraNavigationHeader from "@/reusable_sections/Header"
import ArchiveTitleSectionSection from "./sections/ArchiveTitleSectionSection"
import ShopContent from "./sections/ShopContent"
import TerminalFooter from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <TrendMitraNavigationHeader />
      <ArchiveTitleSectionSection />
      <ShopContent />
      <TerminalFooter />
    </div>
  )
}
